import { Controller } from "@hotwired/stimulus"

// Enables or disables a group of fields from one checkbox.
//
// Usage: data-controller="checkbox-enables"
//        data-checkbox-enables-target="trigger"  on the checkbox
//        data-checkbox-enables-target="field"    on each input/select to gate
//        data-action="change->checkbox-enables#toggle" on the checkbox
//
// Disabled fields are not submitted, which is deliberate: unticking the box
// leaves whatever was stored untouched rather than clearing it.
export default class extends Controller {
  static targets = ["trigger", "field"]

  connect() {
    this.toggle()
  }

  toggle() {
    const enabled = this.triggerTarget.checked

    this.fieldTargets.forEach(field => {
      field.disabled = !enabled
      // Browsers grey a disabled input but not a disabled select, so carry the
      // cue explicitly — otherwise one field of the group looks still editable.
      field.classList.toggle("opacity-50", !enabled)
      field.closest(".form-group, .col-md-4")?.classList.toggle("text-muted", !enabled)
    })
  }
}
